export const APPRAISAL_REFRESH_MODULE = 'AppraisalRefreshModule';
export const SOFTPULL_MODULE = 'SoftPullModule';
